import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

export const BulkActionToolTip = () => {
  return (
    <Box>
      <Box>
        <>
          <Typography
            className="typo-text headline6_size"
            data-testid={`bulk-action-tooltip-intro`}
          >
            {t('userManagement.bulkUserHelp.tooltip.intro')}
          </Typography>
          <ul
            data-testid={`bulk-action-tooltip-step-1-step1-step-2-step2-step-3-step3`}
          >
            <li data-testid={`bulk-action-tooltip-step-1-step1`}>
              <strong data-testid={`bulk-action-tooltip-step-1`}>
                Step 1:
              </strong>{' '}
              <span data-testid={`bulk-action-tooltip-step1`}>
                {t('userManagement.bulkUserHelp.tooltip.steps.step1')}
              </span>
            </li>
            <li data-testid={`bulk-action-tooltip-step-2-step2`}>
              <strong data-testid={`bulk-action-tooltip-step-2`}>
                Step 2:
              </strong>{' '}
              {t('userManagement.bulkUserHelp.tooltip.steps.step2')}
            </li>
            <li data-testid={`bulk-action-tooltip-step-3-step3`}>
              <strong data-testid={`bulk-action-tooltip-step-3`}>
                Step 3:
              </strong>{' '}
              {t('userManagement.bulkUserHelp.tooltip.steps.step3')}
            </li>
          </ul>
          <Typography
            variant="body1"
            data-testid={`bulk-action-tooltip-step4intro`}
          >
            <strong data-testid={`bulk-action-tooltip-step4intro-btn`}>
              {t('userManagement.bulkUserHelp.tooltip.steps.step4Intro')}
            </strong>
          </Typography>
          <Typography
            className="typo-text body2_size"
            data-testid={`bulk-action-tooltip-step4body`}
          >
            {t('userManagement.bulkUserHelp.tooltip.steps.step4Body')}
          </Typography>
          <Typography
            className="typo-text body2_size"
            data-testid={`bulk-action-tooltip-step4action`}
          >
            {t('userManagement.bulkUserHelp.tooltip.steps.step4Action')}
          </Typography>
          <Typography
            className="typo-text body2_size"
            data-testid={`bulk-action-tooltip-example`}
          >
            <strong data-testid={`bulk-action-tooltip-example-btn`}>
              {t('userManagement.bulkUserHelp.tooltip.example')}
            </strong>
          </Typography>
          <Typography
            className="typo-text body2_size"
            data-testid={`bulk-action-tooltip-note`}
          >
            {t('userManagement.bulkUserHelp.tooltip.note')}
          </Typography>
          <Typography
            className="typo-text body2_size"
            color="text.secondary"
            data-testid={`bulk-action-tooltip-contact`}
          >
            {t('userManagement.bulkUserHelp.tooltip.contact')}
          </Typography>
        </>
      </Box>
    </Box>
  );
};

export const RightsTooltip = () => {
  return (
    <p data-testid={`bulk-action-tooltip-rights-tooltip`}>
      {t('userManagement.bulkAction.rightsTooltip')}
    </p>
  );
};
